var _style, _path, _line, _line2, _line3, _line4, _line5, _line6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#ABB4BC;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#ABB4BC;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#ABB4BC;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#ABB4BC;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#ABB4BC;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:3;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16,24c3.6,0,7.1,0.7,10.2,2.1c1.8-2.2,2.8-5,2.8-8.1c0-7.2-5.8-13-13-13S3,10.8,3,18c0,3.1,1.1,5.9,2.8,8.1 C8.9,24.7,12.4,24,16,24z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 16,
    y1: 8,
    x2: 16,
    y2: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 8.9,
    y1: 10.9,
    x2: 10.3,
    y2: 12.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 6,
    y1: 18,
    x2: 8,
    y2: 18
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 26,
    y1: 18,
    x2: 24,
    y2: 18
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 23.1,
    y1: 10.9,
    x2: 21.7,
    y2: 12.3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 16,
    y1: 24,
    x2: 20,
    y2: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.67eb7b47.svg";
export { ForwardRef as ReactComponent };